define(function(require, exports, module) {
    'use strict';

    const Class = require('Class');
    const config = require('config');

    const secureFetch = function(url, options) {
        // Edge workaround, because `fetch` returns promise without `finally`
        return new window.Promise(function(resolve, reject) {
            window.fetch(url, options).then(resolve, reject);
        });
    };

    module.exports = Class.create({
        lastInput: '',
        abortController: null,

        NETWORK_ERROR: -1,
        PARSE_ERROR: -2,
        ABORT_ERROR: -3,
        NOT_VALID_ERROR: -4,

        initialize: function() {
            const postCodeCfg = config.get('postcodeConfiguration');

            this.enabled = postCodeCfg.reverseProxyURL
                && config.get('isPostcodeEnabled')
                && config.get('postcodeProvider') === 'Swiss';
            this.config = {
                ...postCodeCfg,
                url: postCodeCfg.reverseProxyURL
            };
        },

        search: function(input, prevSearchResult) {
            const searchText = input.trim();
            this.cancelSearch();
            this.lastInput = searchText;

            return this.isValid(searchText)
                ? this.fetch(this.prepareRequest(searchText, prevSearchResult))
                : window.Promise.reject({
                    errorCode: this.NOT_VALID_ERROR
                });
        },

        cancelSearch: function() {
            this.abortController?.abort();
        },

        parseResponse: function(response) {
            return response.json()
                .then((data) => {
                    const status = Number.parseInt(data?.QueryAutoComplete2Result?.Status);
                    const results = data?.QueryAutoComplete2Result?.AutoCompleteResult || [];

                    if (status !== 0) {
                        return {
                            errorCode: status
                        };
                    }

                    const parsed = results.map((item) => ({
                        zip: item.Zipcode,
                        city: item.TownName,
                        streetName: item.Streetname,
                        houseNumber: item.HouseNumber + item.HouseNumberAddition
                    }));

                    return this.sort(parsed);
                })
                .catch(this.handleParseError.bind(this));
        },

        handleParseError: function(error) {
            throw {
                ...error,
                errorCode: this.PARSE_ERROR
            };
        },

        handleFetchError: function(error) {
            throw {
                ...error,
                errorCode: error.name === 'AbortError' ? this.ABORT_ERROR : this.NETWORK_ERROR
            };
        },

        fetch: function(params) {
            this.abortController = new AbortController();

            const url = this.config.url;
            const signal = this.abortController.signal;

            return secureFetch(url, {
                method: 'POST',
                signal: signal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
            })
                .then(this.parseResponse.bind(this))
                .catch(this.handleFetchError.bind(this));
        },

        highlightResult: function(formattedString) {
            var regexp = function(str) {
                return new RegExp('(' + str.replace(/\./g, '\\.') + ')(?![^<]*>|[^<>]*<\/)', 'i');
            };
            var highlight = function(str, re) {
                return str.replace(re, '<span class="highlight">$1</span>');
            };

            if (Array.isArray(this.lastInput)) {
                return this.lastInput.map(regexp).reduce(highlight, formattedString);
            }

            if (typeof this.lastInput === 'string') {
                return highlight(formattedString, regexp(this.lastInput));
            }

            return formattedString;
        },

        format: function(row) {
            return row;
        },

        /**
         * @param {string} searchText
         * @return {boolean}
         */
        // eslint-disable-next-line no-unused-vars
        isValid: function(searchText) {
            return true;
        },

        /**
         * @param {string} input
         * @param {Object} [prevSearchResult]
         * @return {Object}
         */
        // eslint-disable-next-line no-unused-vars
        prepareRequest: function(input, prevSearchResult) {
            return {
                request: {
                    Onrp: 0,
                    Zipcode: '',
                    ZipAddition: '',
                    TownName: '',
                    StrId: 0,
                    Streetname: '',
                    HouseKey: 0,
                    HouseNumber: '',
                    HouseNumberAddition: ''
                },
                zipOrderMode: 0
            };
        },

        /**
         * @param {Array} rows
         * @return {Array}
         */
        sort: function(rows) {
            return rows;
        }
    });
});
